import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration, NumberFormat,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Tabs, Tab, Accordion
} 
from '../../noser-hris-component';

class Employee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userinfo        :   [],
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,
            
            
            /*PROFILE*/
            nickName        :   "",
            firstName       :   "",
            middleName      :   "",
            lastName        :   "",
            suffixName      :   "",
            homeNumber      :   "",
            officeNumber    :   "",
            mobileNumber    :   "",
            emailAddress    :   "",
            facebook        :   "",
            twitter         :   "",
            dateofBirth     :   "",
            placeofBirth    :   "",
            height          :   "",
            weight          :   "",
            languageSpoken  :   "",
            hobbies         :   "",
            contactName     :   "",
            contactNumber   :   "",
            contactRelation :   "",
            sssNumber       :   "",
            tinNumber       :   "",
            phicNumber      :   "",
            hdmfNumber      :   "",
            
            nationalityId   :   "",
            religionId      :   "",
            genderId        :   "",
            gender          :   "", 
            arrangementId   :   "",
            bloodtypeId     :   "",
            civilstatusId   :   "",
            civilstatus     :   "",

            

            
            genderDDL       :   [
                {"id":"1","name":"MALE"},
                {"id":"2","name":"FEMALE"}
            ],
            
            suffixDDL: [
                {name: '', value: "",},
                {name: 'SR',               value: 'SR',},
                {name: 'JR',               value: 'JR',},
                {name: 'I',              value: 'I',},
                {name: 'II',              value: 'II',},
                {name: 'III',              value: 'III',},
                {name: 'IV',              value: 'IV',},
                {name: 'V',              value: 'V',},
                {name: 'VI',              value: 'VI',},
                {name: 'VII',              value: 'VII',},
                {name: 'VIII',              value: 'VIII',},
                {name: 'IX',              value: 'IX',},
                {name: 'X',              value: 'X',},
            ],
            civilstatusDDL   :   [
                {"id":"1","name":"SINGLE"},
                {"id":"2","name":"MARRIED"},
                {"id":"3","name":"DIVORCED"},
                {"id":"4","name":"SEPARATED"}
            ],
            nationalityDDL  :   [],
            religionDDL     :   [],
            arrangementDDL  :   [],
            bloodtypeDDL    :   [],
            
            /*201*/
            divisionId      :   "",
            departmentId    :   "",
            sectionId       :   "",
            positionId      :   "",
            employmentId    :   "",
            cardtypeId      :   "",
            paytypeId       :   "",
            paymodeId       :   "",
            periodtypeId    :   "",
            scheduleId      :   "",
            approver1Id     :   "",
            approver2Id     :   "",
            salaryRate      :   "",
            seaRate         :   "",
            ecolaRate       :   "",
            colaRate        :   "",
            isdefaultLocation:  "",
            cardNumber      :   "",
            dateHired       :   "",
            dateResigned    :   "",
            contractStart   :   "",
            contractEnd     :   "",

            location        :   "",
            position        :   "",
            employment      :   "",
            cardtype        :   "",
            paytype         :   "",
            paymode         :   "",
            periodtype      :   "",
            schedule        :   "",
            approver1       :   "",
            approver2       :   "",
            remarks         :   "",

            

            requestDate     :    "",
            pullOutDate     :    "",
            returnDate      :    "",

            divisionDDL     :   [],
            departmentDDL   :   [],
            sectionDDL      :   [],
            positionDDL    :   [],
            employmentDDL  :   [],
            cardtypeDDL    :   [],
            paytypeDDL     :   [],
            paymodeDDL     :   [],
            scheduleDDL    :   [],
            periodtypeDDL  :   [],
            periodtypeList :   [],
            
            backgroundGRID :   [],
            addressGRID    :   [],
            educationGRID  :   [],

            backgroundGRIDDel :   [],
            addressGRIDDel    :   [],
            educationGRIDDel  :   [],

            addrtypeDDL    :   [
                {"value":"0","label":"CURRENT ADDRESS"},
                {"value":"1","label":"REGISTERED ADDRESS"},
                {"value":"2","label":"PROVINCIAL ADDRESS"},
                {"value":"3","label":"CORRESPONDENCE ADDRESS"},
                {"value":"4","label":"FOREIGN ADDRESS"}
            ],
            roleDDL         :   [
                {"value":"0","label":"FATHER"},
                {"value":"1","label":"MOTHER"},
                {"value":"2","label":"SPOUSE"},
                {"value":"3","label":"BROTHER"},
                {"value":"4","label":"SISTER"},
                {"value":"5","label":"CHILD"},
            ],
            levelDDL         :   [
                {"value":"0","label":"COLLEGE"},
                {"value":"1","label":"HIGH SCHOOL"},
                {"value":"5","label":"SENIOR HIGH SCHOOL"},
                {"value":"4","label":"JUNIOR HIGH SCHOOL"},
                {"value":"2","label":"ELEMENTARY"},
                {"value":"3","label":"OTHERS"},
            ],
            regionDDL      :   [],
            provinceDDL    :   [],
            cityDDL        :   [],            
        }
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
    } 
    componentDidMount(){
        this.GetNationalities()
    }
    GetNationalities = async()=> {
        this.setState({isloading:true})
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "SectionId"     :   "",
            "DepartmentId"  :   "",
            "Name"          :   ""
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetNationalities",  params)
        .then(res => {
            const data = res.data;
            this.setState({nationalityDDL:data.nationalities});
        })
        this.GetReligions()
    }
    GetReligions = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetReligions",  params)
        .then(res => {
            const data = res.data;
            this.setState({religionDDL:data.religions});
        })
        this.GetLivingArrangements()
    }
    GetLivingArrangements = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetLivingArrangements",  params)
        .then(res => {
            const data = res.data;
            this.setState({arrangementDDL:data.livingArrangements});
        })
        this.GetBloodTypes()
    }
    GetBloodTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetBloodTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({bloodtypeDDL:data.bloodTypes});
        })
        this.GetPositions()
    }
    GetPositions = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "SectionId"     :   "",
            "DepartmentId"  :   "",
            "Name"          :   ""
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetPositions",  params)
        .then(res => {
            const data = res.data;
            this.setState({positionDDL:data.positions});
        })
        this.GetPayrollTypes()
    }
    GetPayrollTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Timekeeping/GetPayrollTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({paytypeDDL:data.payrollTypes});
        })
        this.GetPayrollModes()
    }
    GetPayrollModes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Timekeeping/GetPayrollModes",  params)
        .then(res => {
            const data = res.data;
            this.setState({paymodeDDL:data.payrollModes});
        })
        this.GetWorkSchedules()
    }
    GetWorkSchedules = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Timekeeping/GetWorkingSchedules",  params)
        .then(res => {
            const data = res.data;
            this.setState({scheduleDDL:data.workSchedules});
            console.log(data)
        })
        this.GetPeriodTypes()
    }
    GetPeriodTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "PayModeId"     :   ""
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Timekeeping/GetPeriodTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({periodtypeList:data.periodTypes});
        })
        this.GetEmployeeStatusTypes()
    }
    GetEmployeeStatusTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetEmployeeStatusTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({employmentDDL:data.statusTypes});
        })
        this.GetPayCardTypes()
    }
    GetPayCardTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetPayCardTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({cardtypeDDL:data.payCardTypes});
        })
        this.GetRegions()
    }
    GetRegions = async () => {

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "Name":""
        };
        await
        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetRegions",  params)
        .then(res => {
            let regionDDL = []
            res.data.regions.map(function(itm){
                regionDDL.push({
                    value : itm.id,
                    label : itm.name,
                })
            })
            this.setState({regionDDL:regionDDL})
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
        this.GetProvinces()
    }
    GetProvinces = async () => {
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "Region": ""
        };
        await
        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetProvinces",  params)
        .then(res => {
            let provinceDDL = []
            res.data.provinces.map(function(itm){
                provinceDDL.push({
                    value : itm.id,
                    label : itm.name,
                    regionId:itm.regionId
                })
            })
            this.setState({provinceDDL:provinceDDL})
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
        this.GetCities()
    }
    GetCities = async () => {

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "Name":"",
            "ProvinceName": ""
        };
        await
         axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetCities",  params)
        .then(res => {
            let cityDDL = []
            res.data.cities.map(function(itm){
                cityDDL.push({
                    value : itm.id,
                    label : itm.name,
                    provinceId:itm.provinceId
                })
            })
            this.setState({cityDDL:cityDDL,isloading:false})
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    IsValidMobile(val){
        var regex = /^0(9|4)\d{9}$/;
        return !regex.test(val)
    }
    ValidateMobileNumber = (e) =>{
        this.setState({isloading:true})
        if(this.IsValidMobile(e.target.value)){
            alert(e.target.name==="mobileNumber" ? "Mobile number should start with 09 followed by 9 digits." : "Emergency contact number should start with 09 followed by 9 digits.")
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: e.target.name==="mobileNumber" ? "Mobile number should start with 09 followed by 9 digits." : "Emergency contact number should start with 09 followed by 9 digits.",
                fade:true
            });
            return
        }
        this.setState({isloading:false})
    }
    handleSubmit = async()=>{
        
        if(parseFloat(this.state.salaryRate)<=0){
            this.setState({
                isloading:false,
                alerttype:"Error!",
                isshow:true,
                color:"danger",
                message: "Invalid salary rate.",
                fade:true
            });
            return
        }
        this.setState({isloading:true})
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.userinfo.clientId,
            "UserId":this.state.userinfo.userId,
            "Title":this.state.title,
            "FirstName":this.state.firstName,
            "MiddleName":this.state.middleName,
            "LastName":this.state.lastName,
            "SuffixName":this.state.suffixName,
            "NickName":this.state.nickName,
            "DateOfBirth": moment(this.state.dateofBirth).format("MM/DD/YYYY"),
            "PlaceOfBirth":this.state.placeofBirth,
            "Gender":this.state.gender,
            "CivilStatus":this.state.civilstatus,
            "LivingArrangementId":this.state.arrangementId,
            "BloodTypeId":this.state.bloodtypeId,
            "Hobbies":this.state.hobbies,
            "Height":this.state.height,
            "Weight":this.state.weight,
            "TINNumber":this.state.tinNumber,
            "SSSNumber":this.state.sssNumber,
            "PHICNumber":this.state.phicNumber,
            "HDMFNumber":this.state.hdmfNumber,
            "NationalityId":this.state.nationalityId,
            "ReligionId":this.state.religionId,
            "Facebook":this.state.facebook,
            "Twitter":this.state.twitter,
            "EmailAddress":this.state.emailAddress,
            "MobileNumber":this.state.mobileNumber,
            "HomePhoneNumber":this.state.homeNumber,
            "OfficePhoneNumber":this.state.officeNumber,
            "SpecialSkills":this.state.specialSkills,
            "LanguageSpoken":this.state.languageSpoken,
            "EmergencyContactNumber":this.state.contactNumber,
            "EmergencyContactName":this.state.contactName, 
            "EmergencyContactRelation":this.state.contactRelation,
            "PositionId":this.state.positionId,
            "WorkScheduleId":this.state.scheduleId,
            "PayCardTypeId":this.state.cardtypeId,
            "EmploymentTypeId":this.state.employmentId,
            "PayTypeId":this.state.paytypeId,
            "PayModeId":this.state.paymodeId,
            "PeriodTypeId":this.state.periodtypeId,
            "PayCardNumber":this.state.cardNumber,
            "SalaryOffered":this.state.salaryRate,
            "SeaValue":this.state.seaRate,
            "EColaValue":this.state.ecolaRate,
            "ColaValue":this.state.colaRate,
            "DateHired":moment(this.state.dateHired).format("MM/DD/YYYY"),
            "ContractDateStart":moment(this.state.contractStart).format("MM/DD/YYYY"),
            "ContractDateEnd":moment(this.state.contractEnd).format("MM/DD/YYYY"),
            "addresses":this.state.addressGRID.filter(x=>x.isDeleted==='0'),
            "educations":this.state.educationGRID.filter(x=>x.isDeleted==='0'),
            "familyBackgrounds":this.state.backgroundGRID.filter(x=>x.isDeleted==='0'),
        };
        console.log(params)
        //return 
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Manning/AddEmployment",  params)
        .then(res => {
            const data = res.data
            this.setState({
                isloading   :   false,
                alerttype   :   data.status=="1" ? "Success!" : "!Error",
                isshow      :   true,
                color       :   data.status=="1" ? "success" : "danger",
                message     :   data.message,
                fade        :   true,
                name        :   ''
            });
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    }
    handleChanged =(e)=>{
        this.setState({[e.target.name] : e.target.value,isshow:false,message:""})
        //console.log(e.target.name + " " + e.target.value)
    }
    handleChangedDDL = name => e =>{
        this.setState({isshow:false,message:""})
        if(e.length===0) {
            this.setState({[name]:"",isshow:false,message:""}); 
            if(name==="paymodeId"){
                this.setState({periodtypeDDL:[]})
            }
            return
        }
        if(name==="genderId"){
            this.setState({gender:e[0].name})
        }
        else if(name==="civilstatusId"){
            this.setState({civilstatus:e[0].name})
        }
        else{
            this.setState({[name]:e[0].id})
        }
        if(name==="paymodeId"){
            this.setState({periodtypeDDL:this.state.periodtypeList.filter(x=>x.payModeId===e[0].id)})
        }
    }
    handleChangedDate = name => date =>{
        this.setState({[name]:date})
    }
    IsDecimal(evt)
    {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode( key );
        var regex = /^\d*\.?(?:\d{1,2})?$/;
        if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
        }
    }
    render(){
        const addrCol = [
            {
                dataField: 'typeId',
                text: 'TYPE',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'8%'}},
                style:{textAlign:'left',width:'8%'},
                formatter: (cell, row) => {
                    if(row.typeId!=='' || row.typeId!==null || typeof row.typeId!=='undefined'){
                        if(this.state.addrtypeDDL.filter(x => x.value == cell).length>0)
                            return this.state.addrtypeDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.addrtypeDDL
                },
                validator: (newValue, row, column) => {
                    if(this.state.addressGRID.filter(x=>x.typeId===newValue).length>0)
                    return {
                        valid: false,
                        message:"Select address type already exist."
                      };
                    return true;   
                }
            },
            {
                dataField: 'regionId',
                text: 'REGION',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'15%'}},
                style:{textAlign:'left',width:'15%'},
                formatter: (cell, row) => {
                    if(row.regionId!=='' || row.regionId!==null || typeof row.regionId!=='undefined'){
                        if(this.state.regionDDL.filter(x => x.value == cell).length>0)
                            return this.state.regionDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.regionDDL
                },
                validator: (newValue, row, column) => {
                    if (row.typeId==="") {
                      return {
                        valid: false,
                        message:"Please select address type."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'provinceId',
                text: 'PROVINCE',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'15%'}},
                style:{textAlign:'left',width:'15%'},
                formatter: (cell, row) => {
                    if(row.provinceId!=='' && row.provinceId!==null || typeof row.provinceId!=='undefined'){
                        if(this.state.provinceDDL.filter(x => x.value == cell).length>0)
                            return this.state.provinceDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    getOptions: (setOptions, { row, column }) => {
                        return this.state.provinceDDL.filter(x=>x.regionId==row.regionId);
                    }
                },
                validator: (newValue, row, column) => {
                    if (row.regionId==="") {
                      return {
                        valid: false,
                        message:"Please select region address."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'cityId',
                text: 'CITY',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'15%'}},
                style:{textAlign:'left',width:'15%'},
                formatter: (cell, row) => {
                    if(row.cityId!=='' && row.cityId!==null || typeof row.cityId!=='undefined'){
                        if(this.state.cityDDL.filter(x => x.value == cell).length>0)
                            return this.state.cityDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    getOptions: (setOptions, { row, column }) => {
                        return this.state.cityDDL.filter(x=>x.provinceId==row.provinceId);
                    }
                },
                validator: (newValue, row, column) => {
                    if (row.provinceId==="") {
                      return {
                        valid: false,
                        message:"Please select province address."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'houseNumber',
                text: 'House Number',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'10%'}},
                style:{textAlign:'left',width:'10%'},
                validator: (newValue, row, column) => {
                    if (row.cityId==="") {
                      return {
                        valid: false,
                        message:"Please select city address."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'streetName',
                text: 'STREET NAME',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'10%'}},
                style:{textAlign:'left',width:'10%'},
                validator: (newValue, row, column) => {
                    if (row.houseNumber==="") {
                      return {
                        valid: false,
                        message:"Please enter house number."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'barangay',
                text: 'BARANGAY',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'10%'}},
                style:{textAlign:'left',width:'10%'},
                validator: (newValue, row, column) => {
                    if (row.streetName==="") {
                      return {
                        valid: false,
                        message:"Please enter street name."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'postalCode',
                text: 'POSTAL CODE',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%'}},
                style:{textAlign:'center',width:'10%'},
                validator: (newValue, row, column) => {
                    if (this.ValidNumeric(newValue)) {
                      return {
                        valid: false,
                        message:"Value must be numeric."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'action',
                text: 'ACTION',
                editable:false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'7%'}
                },
                style:{textAlign:'center',width:'7%'},
                formatter   :   (cell, row, isSelect) => {
                    return (
                        <Button 
                            onClick={e => this.handleRemoveAddress(row.id)}
                            style={{height:'18px',paddingTop:'0',marginTop:'-4px',fontSize:'11px'}} 
                            variant="link"
                    >REMOVE</Button>
                    );
                },
            }
        ]
        const fbCol = [
            {
                dataField: 'roleId',
                text: 'ROLE',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'10%'}},
                style:{textAlign:'left',width:'10%'},
                formatter: (cell, row) => {
                    if(row.roleId!=='' || row.roleId!==null || typeof row.roleId!=='undefined'){
                        if(this.state.roleDDL.filter(x => x.value == cell).length>0)
                            return this.state.roleDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.roleDDL
                },
                validator: (newValue, row, column) => {
                    if(this.state.backgroundGRID.filter(x=>x.roleId===newValue).length>0 && newValue==="0")
                    return {
                        valid: false,
                        message:"Cannot set multiple for role father."
                      };
                    if(this.state.backgroundGRID.filter(x=>x.roleId===newValue).length>0 && newValue==="1")
                    return {
                        valid: false,
                        message:"Cannot set multiple for role mother."
                    };
                    if(this.state.backgroundGRID.filter(x=>x.roleId===newValue).length>0 && newValue==="2")
                    return {
                        valid: false,
                        message:"Cannot set multiple for role spouse."
                    };
                    return true;   
                }
            },
            {
                dataField: 'name',
                text: 'Name',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'20%'}},
                style:{textAlign:'left',width:'20%'},
                validator: (newValue, row, column) => {
                    if (row.roleId==="") {
                      return {
                        valid: false,
                        message:"Please enter role."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'age',
                text: 'AGE',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%'}},
                style:{textAlign:'center',width:'10%'},
                validator: (newValue, row, column) => {
                    if (row.name==="") {
                        return {
                          valid: false,
                          message:"Please enter name."
                        };
                    } 
                    if (this.ValidNumeric(newValue)) {
                      return {
                        valid: false,
                        message:"Value must be numeric."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'occupation',
                text: 'OCCUPATION',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'15%'}},
                style:{textAlign:'center',width:'15%'},
                validator: (newValue, row, column) => {
                    if (row.age==="") {
                        return {
                          valid: false,
                          message:"Please enter age."
                        };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'company',
                text: 'COMPANY',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'38%'}},
                style:{textAlign:'left',width:'38%'},
                validator: (newValue, row, column) => {
                    if (row.occupation==="") {
                        return {
                          valid: false,
                          message:"Please enter company."
                        };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'action',
                text: 'ACTION',
                editable:false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'7%'}
                },
                style:{textAlign:'center',width:'7%'},
                formatter   :   (cell, row, isSelect) => {
                    return (
                        <Button 
                        onClick={e=>this.handleClickBackgroundRemove(row.id)}
                            style={{height:'18px',paddingTop:'0',marginTop:'-4px',fontSize:'11px'}} 
                            variant="link"
                    >REMOVE</Button>
                    );
                },
            }
        ]
        const eduCol = [
            {
                dataField: 'levelId',
                text: 'LEVEL',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'10%'}},
                style:{textAlign:'left',width:'10%'},
                formatter: (cell, row) => {
                    if(row.levelId!=='' || row.levelId!==null || typeof row.levelId!=='undefined'){
                        if(this.state.levelDDL.filter(x => x.value == cell).length>0)
                            return this.state.levelDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.levelDDL
                },
                validator: (newValue, row, column) => {
                    if(this.state.educationGRID.filter(x=>x.levelId===newValue).length>0)
                    return {
                        valid: false,
                        message:"Selected level already exist."
                      };
                    return true;   
                }
            },
            {
                dataField: 'schoolName',
                text: 'SCHOOL NAME',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'20%'}},
                style:{textAlign:'left',width:'20%'},
                validator: (newValue, row, column) => {
                    if(row.levelId==="")
                    return {
                        valid: false,
                        message:"Please select school level."
                      };
                    return true;   
                }
            },
            {
                dataField: 'course',
                text: 'COURSE',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'15%'}},
                style:{textAlign:'left',width:'15%'},
                validator: (newValue, row, column) => {
                    if(row.schoolName==="")
                    return {
                        valid: false,
                        message:"Please enter school name."
                      };
                    return true;   
                }
            },
            {
                dataField: 'startYear',
                text: 'START YEAR',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%'}},
                style:{textAlign:'center',width:'10%'},
                validator: (newValue, row, column) => {
                    if(row.course==="" && row.levelid==="0")
                        return {
                            valid: false,
                            message:"Please enter course."
                    };
                    if (this.ValidNumeric(newValue)) {
                      return {
                        valid: false,
                        message:"Value must be numeric."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'endYear',
                text: 'END YEAR',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'10%'}},
                style:{textAlign:'left',width:'10%'},
                validator: (newValue, row, column) => {
                    if(row.startYear==="")
                        return {
                        valid: false,
                        message:"Please enter start year."
                    };
                    if (this.ValidNumeric(newValue)) {
                      return {
                        valid: false,
                        message:"Value must be numeric."
                      };
                    } 
                    return true;   
                }
            },
            {
                dataField: 'honorRecieved',
                text: 'HONOR',
                editable: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'28%'}},
                style:{textAlign:'left',width:'28%'},
                validator: (newValue, row, column) => {
                    if(row.endYear==="")
                        return {
                        valid: false,
                        message:"Please enter start year."
                    };
                    return true;   
                }
            },
            {
                dataField: 'action',
                text: 'ACTION',
                editable:false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'7%'}
                },
                style:{textAlign:'center',width:'7%'},
                formatter   :   (cell, row, isSelect) => {
                    return (
                        <Button 
                            onClick={e=>this.handleRemoveEducation(row.id)}
                            style={{height:'18px',paddingTop:'0',marginTop:'-4px',fontSize:'11px'}} 
                            variant="link"
                    >REMOVE</Button>
                    );
                },
            }
        ]
        const selectrowAddr = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        };
        const selectrowFB = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        };
        const selectrowEdu = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        };
        return(
            <div>
            <Banner />
            <Container className="themed-container" fluid={true}>
            <Card className="mt-5">
            <Card.Header>Create New Employee</Card.Header>
            <Card.Body>
            <Form>
                <Alert style={{'overflow-wrap': 'break-word'}} isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                    <div className={this.state.color}></div> 
                    {this.state.message}
                </Alert>
                <Tabs className="mt-2" defaultActiveKey="default" transition={false} id="noanim-tab-example">
                    <Tab eventKey="default" title="Employee Profiles">
                        <Accordion className="mt-2"  defaultActiveKey="0">
                        <Card className="card-tab">
                        <div className="card-header-tab">
                            <Accordion.Toggle as={Button} variant="link" eventKey="0" style={{color: "#FFFFFF"}}>
                                    PROFILE INFORMATION
                            </Accordion.Toggle>
                        </div>
                        <Accordion.Collapse eventKey="0">
                        <Card.Body>
                        <Form>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            FIRST NAME
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    value={this.state.firstName}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                    disabled={this.state.disableLibrarian}
                                /> 
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            MIDDLE NAME
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="middleName"
                                    name="middleName"
                                    value={this.state.middleName}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            LAST NAME
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    value={this.state.lastName}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                            <Form.Label column sm="1" style={{fontWeight : "bold"}}>
                            SUFFIX NAME
                            </Form.Label>
                            <Col sm="1">
                                <Form.Control
                                    as="select"
                                    onChange={this.handleChanged}
                                    name="suffixName"
                                    value={this.state.suffixName}
                                >
                                {this.state.suffixDDL.map(item => (
                                    <option key={item.value} value={item.value}>
                                    {item.name}
                                    </option>
                                ))}
                                </Form.Control>
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            NICK NAME
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="nickName"
                                    name="nickName"
                                    value={this.state.nickName}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            MOBILE NUMBER
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="mobileNumber"
                                    name="mobileNumber"
                                    value={this.state.mobileNumber}
                                    onChange={this.handleChanged}
                                    onBlur={this.ValidateMobileNumber}
                                    autoComplete="off"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            CIVIL STATUS
                            </Form.Label>
                            <Col sm="3">
                                <Typeahead
                                    labelKey='name'
                                    id='civilstatusId'
                                    name='civilstatusId'
                                    onChange={this.handleChangedDDL("civilstatusId")}
                                    options={this.state.civilstatusDDL}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            HOME PHONE NUMBER
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="homeNumber"
                                    name="homeNumber"
                                    value={this.state.homeNumber}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            OFFICE PHONE NUMBER
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="officeNumber"
                                    name="officeNumber"
                                    value={this.state.officeNumber}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            FACEBOOK
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="facebook"
                                    name="facebook"
                                    value={this.state.facebook}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            TWITTER
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="twitter"
                                    name="twitter"
                                    value={this.state.twitter}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            NATIONALITY
                            </Form.Label>
                            <Col sm="3">
                                <Typeahead
                                    labelKey='name'
                                    id='nationalityId'
                                    name='nationalityId'
                                    onChange={this.handleChangedDDL("nationalityId")}
                                    options={this.state.nationalityDDL}
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            RELIGION
                            </Form.Label>
                            <Col sm="3">
                                <Typeahead
                                    labelKey='name'
                                    id='religionId'
                                    name='religionId'
                                    onChange={this.handleChangedDDL("religionId")}
                                    options={this.state.religionDDL}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            GENDER
                            </Form.Label>
                            <Col sm="3">
                                <Typeahead
                                    labelKey='name'
                                    name="genderId"
                                    id="genderId"
                                    onChange={this.handleChangedDDL("genderId")}
                                    options={this.state.genderDDL}
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            EMAIL ADDRESS
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="emailAddress"
                                    name="emailAddress"
                                    value={this.state.emailAddress}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            DATE OF BIRTH
                            </Form.Label>
                            <Col sm="3">
                                <DatePicker
                                    id="dateofBirth"
                                    name="dateofBirth"
                                    value={this.state.dateofBirth}
                                    selected={this.state.dateofBirth}
                                    onChange={this.handleChangedDate("dateofBirth")}
                                    minDate={this.minDate}
                                    dateFormat={"MM/dd/yyyy"}
                                    className="form-control"
                                    autoComplete="off"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            PLACE OF BIRTH
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="placeofBirth"
                                    name="placeofBirth"
                                    value={this.state.placeofBirth}
                                    onChange={this.handleChanged} 
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            LIVING ARRANGEMENT
                            </Form.Label>
                            <Col sm="3">
                                <Typeahead
                                    labelKey='name'
                                    id='arrangementId'
                                    name='arrangementId'
                                    onChange={this.handleChangedDDL("arrangementId")}
                                    options={this.state.arrangementDDL}
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            BLOOD TYPE
                            </Form.Label>
                            <Col sm="3">
                                <Typeahead
                                    labelKey='name'
                                    id='bloodtypeId'
                                    name='bloodtypeId'
                                    onChange={this.handleChangedDDL("bloodtypeId")}
                                    options={this.state.bloodtypeDDL}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            HEIGHT
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="height"
                                    name="height"
                                    value={this.state.height}
                                    autoComplete="off"
                                    onChange={this.handleChanged}
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            WEIGHT
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="weight"
                                    name="weight"
                                    value={this.state.weight}
                                    autoComplete="off"
                                    onChange={this.handleChanged}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            LANGUAGE SPOKEN
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="languageSpoken"
                                    name="languageSpoken"
                                    value={this.state.languageSpoken}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            HOBBIES
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="hobbies"
                                    name="hobbies"
                                    onChange={this.handleChanged}
                                    value={this.state.hobbies}
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            EMERGENCY CONTACT NAME
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="contactName"
                                    name="contactName"
                                    value={this.state.contactName}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            EMERGENCY CONTACT NUMBER
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="contactNumber"
                                    name="contactNumber"
                                    value={this.state.contactNumber}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                    onBlur={this.ValidateMobileNumber}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            EMERGENCY CONTACT RELATION
                            </Form.Label>
                            <Col sm="3">
                                <Form.Control 
                                    type="text"
                                    id="contactRelation"
                                    name="contactRelation"
                                    value={this.state.contactRelation}
                                    onChange={this.handleChanged}
                                    autoComplete="off"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            SSS NUMBER
                            </Form.Label>
                            <Col sm="3">
                                <NumberFormat
                                    id="sssNumber"
                                    name="sssNumber"
                                    value={this.state.sssNumber}
                                    onChange={this.handleChanged} 
                                    autoComplete="off"
                                    format="##-#######-#"
                                    className="form-control"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            TIN NUMBER 
                            </Form.Label>
                            <Col sm="3">
                                <NumberFormat
                                    id="tinNumber"
                                    name="tinNumber"
                                    value={this.state.tinNumber}
                                    onChange={this.handleChanged} 
                                    autoComplete="off"
                                    format="###-###-###-###"
                                    className="form-control"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            PHIC NUMBER
                            </Form.Label>
                            <Col sm="3">
                                <NumberFormat
                                    id="phicNumber"
                                    name="phicNumber"
                                    value={this.state.phicNumber}
                                    onChange={this.handleChanged} 
                                    autoComplete="off"
                                    format="##-#########-#"
                                    className="form-control"
                                />
                            </Col>
                            <Col sm="2">
                            </Col>
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                            HDMF NUMBER 
                            </Form.Label>
                            <Col sm="3">
                                <NumberFormat
                                    id="hdmfNumber"
                                    name="hdmfNumber"
                                    value={this.state.hdmfNumber}
                                    onChange={this.handleChanged} 
                                    autoComplete="off"
                                    format="####-####-####"
                                    className="form-control"
                                />
                            </Col>
                        </Form.Group>
                        </Form>
                        </Card.Body>
                        </Accordion.Collapse>
                        </Card>
                        <Card>
                        <div className="card-header-tab">
                            <Accordion.Toggle as={Button} variant="link" eventKey="1" style={{color: "#FFFFFF"}}>
                                    EMPLOYEE ADDRESSESS
                            </Accordion.Toggle>
                        </div>
                        <Accordion.Collapse eventKey="1">
                            <div>
                            <BootstrapTable
                                striped
                                hover
                                condensed
                                keyField = "id"
                                data = { this.state.addressGRID }
                                columns = { addrCol}
                                selectRow = { selectrowAddr }
                                cellEdit = { cellEditFactory({ 
                                    mode: 'dbclick', 
                                    blurToSave: true,
                                    afterSaveCell: (oldValue, newValue, row, column) => { 
                                        //this.GridDataModified(oldValue, newValue, row.id, column.dataField)
                                    }})
                                }
                                rowClasses="noser-table-row-class no-checkbox"
                                noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                            />
                            <Button id="addrid"
                                className="noser-button" 
                                variant="success" 
                                onClick = {this.handleAddAddress}
                                style={{marginLeft:'2px',marginBottom:'4px'}}
                            >ADD</Button>
                            </div> 
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <div className="card-header-tab">
                            <Accordion.Toggle as={Button} variant="link" eventKey="2" style={{color: "#FFFFFF"}}>
                                    FAMILY BACKGROUND
                            </Accordion.Toggle>
                        </div>
                        <Accordion.Collapse eventKey="2">
                            <div>
                                <BootstrapTable
                                    striped
                                    hover
                                    condensed
                                    keyField = "id"
                                    data = { this.state.backgroundGRID }
                                    columns = { fbCol}
                                    selectRow = { selectrowFB }
                                    cellEdit = { cellEditFactory({ 
                                        mode: 'dbclick', 
                                        blurToSave: true,
                                        afterSaveCell: (oldValue, newValue, row, column) => { 
                                            //this.GridDataModified(oldValue, newValue, row.id, column.dataField)
                                        }})
                                    }
                                    rowClasses="noser-table-row-class no-checkbox"
                                    noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                />
                                <Button id="fbid"
                                    className="noser-button" 
                                    variant="success" 
                                    onClick = {this.handleClickBackground}
                                    style={{marginLeft:'2px',marginBottom:'4px'}}
                                >ADD</Button>
                            </div> 
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <div className="card-header-tab">
                            <Accordion.Toggle as={Button} variant="link" eventKey="3" style={{color: "#FFFFFF"}}>
                                    EDUCATION ATTAINMENT
                            </Accordion.Toggle>
                        </div>
                        <Accordion.Collapse eventKey="3">
                            <div>
                                <BootstrapTable
                                    striped
                                    hover
                                    condensed
                                    keyField = "id"
                                    data = { this.state.educationGRID }
                                    columns = { eduCol}
                                    selectRow = { selectrowEdu }
                                    cellEdit = { cellEditFactory({ 
                                        mode: 'dbclick', 
                                        blurToSave: true,
                                        afterSaveCell: (oldValue, newValue, row, column) => { 
                                            //this.GridDataModified(oldValue, newValue, row.id, column.dataField)
                                        }})
                                    }
                                    rowClasses="noser-table-row-class no-checkbox"
                                    noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                />
                                <Button id="eduid"
                                    className="noser-button" 
                                    variant="success" 
                                    onClick = {this.handleAddEducation}
                                    style={{marginLeft:'2px',marginBottom:'4px'}}
                                >ADD</Button>
                            </div>
                        </Accordion.Collapse>
                    </Card>
                        </Accordion>
                    </Tab>
                    <Tab eventKey="201" title="Employee Records">
                    <Accordion className="mt-2"  defaultActiveKey="0">
                    <Card className="card-tab">
                    <div className="card-header-tab">
                        <Accordion.Toggle as={Button} variant="link" eventKey="0" style={{color: "#FFFFFF"}}></Accordion.Toggle>
                    </div>
                    <Accordion.Collapse eventKey="0">
                    <Card.Body>
                        <Form>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                    DIVISION
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='divisionId'
                                        name='divisionId'
                                        onChange={this.handleChangedDDL('divisionId')}
                                        options={this.state.divisionDDL}
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                    DEPARTMENT
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='departmentId'
                                        name='departmentId'
                                        onChange={this.handleChangedDDL('departmentId')}
                                        options={this.state.departmentDDL}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                SECTION
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='sectionId'
                                        name='sectionId'
                                        onChange={this.handleChangedDDL('sectionId')}
                                        options={this.state.sectionDDL}
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                POSITION
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='positionId'
                                        name='positionId'
                                        onChange={this.handleChangedDDL("positionId")}
                                        options={this.state.positionDDL}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                DATE HIRED
                                </Form.Label>
                                <Col sm="3">
                                    <DatePicker
                                        id='dateHired'
                                        name='dateHired'
                                        onChange={this.handleChangedDate('dateHired')}
                                        minDate={this.minDate}
                                        value={this.state.dateHired}
                                        selected={this.state.dateHired}
                                        dateFormat={"MM/dd/yyyy"}
                                        className="form-control"
                                        autoComplete="off"
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                EMPLOYMENT
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='employmentId'
                                        name='employmentId'
                                        onChange={this.handleChangedDDL('employmentId')}
                                        options={this.state.employmentDDL}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                CONTRACT START
                                </Form.Label>
                                <Col sm="3">
                                    <DatePicker
                                        id='contractStart'
                                        name='contractStart'
                                        minDate={this.minDate}
                                        value={this.state.contractStart}
                                        onChange={this.handleChangedDate('contractStart')}
                                        dateFormat={"MM/dd/yyyy"}
                                        className="form-control"
                                        autoComplete="off"
                                        selected={this.state.contractStart}
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                CONTRACT END
                                </Form.Label>
                                <Col sm="3">
                                    <DatePicker
                                        id='contractEnd'
                                        name='contractEnd'
                                        onChange={this.handleChangedDate('contractEnd')}
                                        minDate={this.minDate}
                                        value={this.state.contractEnd}
                                        dateFormat={"MM/dd/yyyy"}
                                        className="form-control"
                                        autoComplete="off"
                                        selected={this.state.contractEnd}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                PAY CARD TYPE
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='cardtypeId'
                                        name='cardtypeId'
                                        onChange={this.handleChangedDDL("cardtypeId")}
                                        options={this.state.cardtypeDDL}
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                PAY CARD NUMBER
                                </Form.Label>
                                <Col sm="3">
                                    <Form.Control 
                                        type="text" 
                                        id="cardNumber"
                                        name="cardNumber"
                                        onChange={this.handleChanged}
                                        value={this.state.cardNumber}
                                        autoComplete="off" 
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                PAY TYPE
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='paytypeId'
                                        name='paytypeId'
                                        onChange={this.handleChangedDDL("paytypeId")}
                                        options={this.state.paytypeDDL}
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                WORK SCHEDULE
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='description'
                                        id='scheduleId'
                                        name='scheduleId'
                                        onChange={this.handleChangedDDL("scheduleId")}
                                        options={this.state.scheduleDDL}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                PAY MODE
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='paymodeId'
                                        name='paymodeId'
                                        onChange={this.handleChangedDDL("paymodeId")}
                                        options={this.state.paymodeDDL}
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                SALARY RATE
                                </Form.Label>
                                <Col sm="3">
                                    <Form.Control 
                                        type="text"
                                        id="salaryRate"
                                        name="salaryRate"
                                        value={this.state.salaryRate}
                                        onChange={this.handleChanged}
                                        onKeyPress={this.IsDecimal.bind(this)}
                                        maxLength="13"
                                        autoComplete="off"
                                    /> 
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                PERIOD TYPE
                                </Form.Label>
                                <Col sm="3">
                                    <Typeahead
                                        labelKey='name'
                                        id='periodtypeId'
                                        name='periodtypeId'
                                        onChange={this.handleChangedDDL("periodtypeId")}
                                        options={this.state.periodtypeDDL}
                                    />
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                SEA RATE
                                </Form.Label>
                                <Col sm="3">
                                    <Form.Control 
                                        type="text"
                                        id="seaRate"
                                        name="seaRate"
                                        value={this.state.seaRate}
                                        onChange={this.handleChanged}
                                        onKeyPress={this.IsDecimal.bind(this)}
                                        maxLength="13"
                                        autoComplete="off"
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                            <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                ECOLA RATE
                                </Form.Label>
                                <Col sm="3">
                                    <Form.Control 
                                        type="text"
                                        id="ecolaRate"
                                        name="ecolaRate"
                                        value={this.state.ecolaRate}
                                        onChange={this.handleChanged}
                                        onKeyPress={this.IsDecimal.bind(this)}
                                        maxLength="13"
                                        autoComplete="off"
                                    /> 
                                </Col>
                                <Col sm="2"></Col>
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                COLA RATE
                                </Form.Label>
                                <Col sm="3">
                                    <Form.Control 
                                        type="text"
                                        id="colaRate"
                                        name="colaRate"
                                        value={this.state.colaRate}
                                        onChange={this.handleChanged}
                                        onKeyPress={this.IsDecimal.bind(this)}
                                        maxLength="13"
                                        autoComplete="off"
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                REMARKS
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control 
                                        type="text"
                                        id="remarks"
                                        name="remarks"
                                        value={this.state.remarks}
                                        onChange={this.handleChanged} 
                                        autoComplete="off"
                                    />
                                </Col>
                            </Form.Group>
                        </Form>
                    </Card.Body>
                    </Accordion.Collapse>
                    </Card>
                    </Accordion>
                    </Tab>
                </Tabs>
            </Form>
            </Card.Body>
            <ButtonToolbar mt="5" style={{marginRight:'13px',marginBottom:'10px'}}>
                <Button className="ml-auto noser-button-mr1" variant="success" onClick = {this.handleSubmit}>Submit</Button>
                <Button  href="/employees" className="noser-button" variant="warning">Back</Button>
            </ButtonToolbar>
            </Card>
            </Container>
            <NoserLoading show={this.state.isloading} />
            </div>
        )
    }
} export default Employee;